import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e925ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-4 mt-s2 tokens-to-add-list" }
const _hoisted_2 = { class: "mr-s1" }

import Icon from '@/components/icon/Icon.vue';
import Notice from '@/components/Notice.vue';
import { format } from '@/utils/format';
import BigNumber from 'bignumber.js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuyTokensNotice',
  props: {
    tokensToAdd: null
  },
  setup(__props: any) {

const props = __props as {
  tokensToAdd: {
    amount: BigNumber;
    symbol: string;
  }[];
}

const { t } = useI18n();



const headerTranslation = t('portfolio.easyModeTranslations.common.notices.addTokens');

const formattedTokensToAdd = computed(() =>
  props.tokensToAdd.map(tokenToAdd => `${format(tokenToAdd.amount)} ${tokenToAdd.symbol}`),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, { icon: "buy" }, {
    "notice-text": _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_unref(headerTranslation)), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formattedTokensToAdd), (tokenToAddInfo) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tokenToAddInfo,
            class: "mb-s2 flex align-items-center"
          }, [
            _createVNode(Icon, {
              name: "addToken",
              size: "16",
              class: "mr-s2"
            }),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('add')), 1),
            _createElementVNode("span", null, _toDisplayString(tokenToAddInfo), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})